import React, { useRef, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { formatChartTitle } from "../../utils";

interface VerticalBarChartData {
  [key: string]: string | number;
}

interface BarSeries {
  dataKey: string;
  label: string;
  color?: string;
}

interface VerticalBarChartProps {
  data: VerticalBarChartData[];
  xAxisKey: string;
  yAxisKey?: string;
  series?: BarSeries[];
  title?: string;
  height?: number;
  color?: string;
  yAxisMin?: number;
  yAxisMax?: number;
}

export const VerticalBarChart: React.FC<VerticalBarChartProps> = ({
  data,
  xAxisKey,
  yAxisKey,
  series,
  title,
  height = 300,
  color = "#4DD0E1",
  yAxisMin,
  yAxisMax,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const formattedTitle = formatChartTitle(title);

  const chartSeries = series
    ? series.map((s) => ({
        dataKey: s.dataKey,
        label: s.label,
        color: s.color || color,
      }))
    : [{ dataKey: yAxisKey!, color: color }];

  return (
    <Box ref={containerRef} sx={{ width: "100%" }}>
      {formattedTitle && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {formattedTitle}
        </Typography>
      )}
      <BarChart
        dataset={data}
        height={height}
        xAxis={[
          {
            scaleType: "band",
            dataKey: xAxisKey,
            disableTicks: true,
          },
        ]}
        yAxis={[
          {
            min: yAxisMin,
            max: yAxisMax,
            disableTicks: true,
          },
        ]}
        series={chartSeries}
        margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
        grid={{ vertical: true }}
        borderRadius={6}
      />
    </Box>
  );
};
